import { createFileRoute } from '@tanstack/react-router'
import { IncomingWebhooks } from '@/components/webhooks/IncomingWebhooks'

export const Route = createFileRoute('/_app/webhooks/incoming')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold tracking-tight">Webhooks Recebidos</h2>
      </div>
      <IncomingWebhooks />
    </div>
  )
}
